import { useGetFinancierDashboardQuery } from '@shared/api';
import {
  LoadingCard,
  ErrorCard,
  RetryButton,
} from './styled';
import { LiquiditySection } from './LiquiditySection';
import { CovenantsSection } from './CovenantsSection';
import { GatesOverviewSection } from './GatesOverviewSection';
import { CashForecastSection } from './CashForecastSection';
import { TaxPositionSection } from './TaxPositionSection';

export function DashboardView() {
  const { data, isLoading, isError, refetch } = useGetFinancierDashboardQuery();

  if (isLoading) {
    return <LoadingCard>Загрузка финансового пульта Финдиректора…</LoadingCard>;
  }

  if (isError || !data) {
    return (
      <ErrorCard>
        <span>Не удалось загрузить данные финансового пульта Финдиректора.</span>
        <RetryButton
          type="button"
          onClick={() => refetch()}
        >
          Повторить
        </RetryButton>
      </ErrorCard>
    );
  }

  const {
    accounts_summary: acc,
    payment_factory: pf,
    tax_summary: tax,
    bank_covenants: covenants,
    cash_flow_forecast_30d: forecast,
  } = data;

  return (
    <>
      {/* 1. Пульт Финдиректора: Банковская ликвидность */}
      <LiquiditySection accountsSummary={acc} />

      {/* 2. Банковские ковенанты */}
      <CovenantsSection covenants={covenants} />

      {/* 3. Сквозной 4-ступенчатый финконтроль */}
      <GatesOverviewSection paymentFactory={pf} />

      {/* 4. 30-дневный платёжный календарь и кассовые разрывы */}
      <CashForecastSection forecast={forecast} />

      {/* 5. Налоговая позиция ЕНС и сальдо НДС */}
      <TaxPositionSection tax={tax} />
    </>
  );
}
